// @core/api/endpoints/fiscalization/register_fiscal_point.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RegisterFiscalPointRequest,
  RegisterFiscalPointResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Register fiscal point
 * Registers a virtual cash register or TSE device with the fiscal provider. Requires prior registration with tax authority.
 */
export async function RegisterFiscalPoint(
  data: RegisterFiscalPointRequest,
  options?: RequestOptions
): Promise<RegisterFiscalPointResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/fiscal-points`;
  const requestOptions = options;
  return client.post<RegisterFiscalPointResponse>(requestPath, data, requestOptions);
}
